import { render, staticRenderFns } from "./VehicleRLS2.vue?vue&type=template&id=66fb6f96&scoped=true"
import script from "./VehicleRLS2.vue?vue&type=script&lang=js"
export * from "./VehicleRLS2.vue?vue&type=script&lang=js"
import style0 from "./VehicleRLS2.vue?vue&type=style&index=0&id=66fb6f96&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66fb6f96",
  null
  
)

export default component.exports